import { useState, useEffect, useCallback } from "react";

export function useAuth() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return false;
    }

    try {
      const res = await fetch('/api/auth/me', {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (!res.ok) {
        throw new Error("Invalid token");
      }

      const data = await res.json();
      setUser(data);
      setLoading(false);
      return true;
    } catch (err) {
      localStorage.clear();
      setUser(null);
      setLoading(false);
      return false;
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  useEffect(() => {
    const handleAuthExpired = () => {
      setUser(null);
    };

    window.addEventListener("auth-expired", handleAuthExpired);

    return () => {
      window.removeEventListener("auth-expired", handleAuthExpired);
    };
  }, []);

  const login = (data) => {
    localStorage.setItem("token", data.token);
    setUser({
      id: data.userId,
      name: data.name,
      isActive: data.isActive,
      lastLoginAt: data.lastLoginAt,
      mustChangePassword: Boolean(data.mustChangePassword),
      usernameChanged: Boolean(data.usernameChanged),
      roles: data.roles ?? [],
      isAdmin: Boolean(data.isAdmin)
    });
  };

  const logout = () => {
    localStorage.clear();
    // Let the reload clear user state without saving this page as an expired-session destination.
    window.location.replace("/");
  };

  return { user, loading, login, logout, checkAuth };
}
